import { BalanceModification } from "./BalanceModification";
import { Currency } from "../../utils/Currency";
import { ChronoUnit } from "@js-joda/core";
export class BalanceModifications {
    _balanceModifications = [];
    constructor(balanceModifications = []) {
        this.balanceModifications = balanceModifications;
    }
    get all() {
        return this._balanceModifications;
    }
    get balanceModifications() {
        return this._balanceModifications;
    }
    set balanceModifications(value) {
        this._balanceModifications = value
            .map((bm) => (bm instanceof BalanceModification ? bm : new BalanceModification(bm)))
            .filter((bm) => bm.amount.greaterThan(0))
            .sort((a, b) => ChronoUnit.DAYS.between(a.date, b.date));
    }
    getById(id) {
        return this._balanceModifications.find((bm) => bm.id === id);
    }
    /** Return the first BalanceModification that came from this depositId. */
    getByDepositId(depositId) {
        return this.all.find((m) => m.metadata?.depositId === depositId);
    }
    get lastModification() {
        return this._balanceModifications[this._balanceModifications.length - 1];
    }
    get firstModification() {
        return this._balanceModifications[0];
    }
    removeMarkedForRemoval() {
        this._balanceModifications = this._balanceModifications.filter((bm) => !bm.markedForRemoval);
    }
    removeBalanceModificationByDepositId(depositId) {
        this._balanceModifications = this._balanceModifications.filter((bm) => !(bm.metadata && bm.metadata.depositId === depositId));
    }
    removeSystemGeneratedBalanceModifications() {
        this._balanceModifications = this._balanceModifications.filter((bm) => bm.metadata && bm.metadata.isSystemGenerated !== true);
    }
    addBalanceModification(balanceModification) {
        // before adding balance modification, lets check if it already exists
        // we will use bm.metadata.depositId, amount, date, and type
        // to find if the balance modification already exists
        const existingBalanceModification = this._balanceModifications.find((bm) => {
            if (bm.metadata && balanceModification.metadata) {
                return bm.metadata.depositId === balanceModification.metadata.depositId && bm.amount.equals(balanceModification.amount) && bm.date.isEqual(balanceModification.date) && bm.type === balanceModification.type;
            }
            return false;
        });
        if (existingBalanceModification) {
            return false;
        }
        else {
            this._balanceModifications.push(balanceModification);
            return true;
        }
    }
    removeBalanceModification(balanceModification) {
        this._balanceModifications = this._balanceModifications.filter((bm) => bm.id !== balanceModification.id);
    }
    removeBalanceModificationAtIndex(index) {
        this._balanceModifications.splice(index, 1);
    }
    getBalanceModificationById(id) {
        return this._balanceModifications.find((bm) => bm.id === id);
    }
    getBalanceModificationIndexById(id) {
        return this._balanceModifications.findIndex((bm) => bm.id === id);
    }
    getBalanceModificationIndex(balanceModification) {
        return this._balanceModifications.findIndex((bm) => bm.id === balanceModification.id);
    }
    getBalanceModificationByIndex(index) {
        return this._balanceModifications[index];
    }
    getBalanceModificationCount() {
        return this._balanceModifications.length;
    }
    resetUsedAmounts() {
        this._balanceModifications.forEach((bm) => bm.resetUsedAmount());
    }
    updateModelValues() {
        this._balanceModifications.forEach((bm) => bm.updateModelValues());
    }
    updateJsValues() {
        this._balanceModifications.forEach((bm) => bm.updateJsValues());
    }
    get summary() {
        let total = Currency.of(0);
        let increases = Currency.of(0);
        let decreases = Currency.of(0);
        this.all.forEach((bm) => {
            if (bm.type === "increase") {
                increases = increases.add(bm.amount);
                total = total.add(bm.amount);
            }
            if (bm.type === "decrease") {
                decreases = decreases.add(bm.amount);
                total = total.subtract(bm.amount);
            }
        });
        return {
            total: total,
            increases: increases,
            decreases: decreases,
        };
    }
    get json() {
        return this._balanceModifications.map((bm) => bm.json);
    }
    get length() {
        return this._balanceModifications.length;
    }
    toCode() {
        // we dont want system generated balance modifications
        return this._balanceModifications
            .filter((bm) => bm.isSystemModification !== true)
            .map((bm) => {
            return `new BalanceModification(${JSON.stringify(bm.json)})`;
        });
    }
    printToConsole() {
        console.log("Balance Modifications");
        console.table(this.all.map((r) => {
            return {
                id: r.id,
                amount: r.amount.toNumber(),
                unusedAmount: r.unusedAmount.toNumber(),
                date: r.date.toString(),
                type: r.type,
                description: r.description,
                metadata: r.metadata,
            };
        }));
    }
}
